import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { ConfirmModal } from '../models/confirm-modal';
import { HardDeleteConfirmModal } from '../models/hard-delete-confirm-modal';

export const useHardDeleteConfirm = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [resolvePromise, setResolvePromise] = useState<(value: string) => void | null>(null);

  const confirmDelete = (msg: string): Promise<string> => {
    setMessage(msg); // Update the message state with the provided message
    setIsVisible(true);
    return new Promise<string>((resolve) => {
      setResolvePromise(() => resolve);
    });
  };

  const handleHardDeleteConfirm = () => {
    if (resolvePromise) resolvePromise('hard');
    setIsVisible(false);
  };

  const handleConfirm = () => {
    if (resolvePromise) resolvePromise('soft');
    setIsVisible(false);
  };

  const handleCancel = () => {
    if (resolvePromise) resolvePromise('cancel');
    setIsVisible(false);
  };

  const modalDelete = isVisible
    ? ReactDOM.createPortal(
      <HardDeleteConfirmModal
        message={message} // Pass the updated message state to the ConfirmModal
        onHardDeleteConfirm={handleHardDeleteConfirm}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />,
      document.body
    )
    : null;

  return { confirmDelete, modalDelete };
};
